export const NoSparklersIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
        <path
          d="M6.15005 5.2561L5.25419 6.15196C5.17462 6.23071 5.11146 6.32446 5.06835 6.42777C5.02525 6.53109 5.00305 6.64192 5.00305 6.75387C5.00305 6.86582 5.02525 6.97666 5.06835 7.07997C5.11146 7.18329 5.17462 7.27703 5.25419 7.35578L16.6484 18.75C16.7272 18.8296 16.8209 18.8928 16.9242 18.9359C17.0276 18.979 17.1384 19.0012 17.2503 19.0012C17.3623 19.0012 17.4731 18.979 17.5764 18.9359C17.6798 18.8928 17.7735 18.8296 17.8522 18.75L18.7481 17.8542C18.8285 17.7759 18.8925 17.6823 18.9361 17.5789C18.9798 17.4755 19.0022 17.3645 19.0022 17.2523C19.0022 17.14 18.9798 17.029 18.9361 16.9256C18.8925 16.8222 18.8285 16.7286 18.7481 16.6503L7.35387 5.2561C7.2756 5.17568 7.18202 5.11176 7.07864 5.06811C6.97526 5.02446 6.86418 5.00197 6.75196 5.00197C6.63974 5.00197 6.52866 5.02446 6.42528 5.06811C6.3219 5.11176 6.22831 5.17568 6.15005 5.2561Z"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.50165 10.6033L10.6013 8.50361"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.80176 17.9023H12.6013"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2015 16.5026V19.3021"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4009 6.10382H14.2004"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8007 4.70403V7.5036"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.0022 11.4028H6.40198"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.70209 10.703V12.1028"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
